export const authKeys = {
  me: ['auth', 'me'] as const,
};

export const LOGIN_STEPS: readonly string[] = [
  'Buka bot Kasboek di Telegram.',
  'Kirim perintah /login.',
  'Ketuk link yang dikirim bot. Link berlaku 5 menit dan hanya sekali pakai.',
];
